import { Pipe, PipeTransform } from '@angular/core';
import { SuffixResource } from '@models/resources/suffix.model';
import { Name } from 'src/app/models/booking.models';

@Pipe({ name: 'passengerName', standalone: true })
export class PassengerNamePipe implements PipeTransform {
  transform(
    name: Name | null | undefined,
    suffixes?: SuffixResource[] | null,
  ): string {
    if (!name) {
      return '';
    }
    return `${name.first}${name.middle ? ` ${name.middle}` : ''} ${name.last}${
      name.suffix
        ? `, ${
            suffixes
              ? suffixes.find((s) => s.suffixCode === name.suffix)?.name
              : name.suffix
          }`
        : ''
    }`;
  }
}
